import { render, staticRenderFns } from "./CommitButton.vue?vue&type=template&id=4d43b633&scoped=true&"
import script from "./CommitButton.vue?vue&type=script&lang=js&"
export * from "./CommitButton.vue?vue&type=script&lang=js&"
import style0 from "./CommitButton.vue?vue&type=style&index=0&id=4d43b633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43b633",
  null
  
)

export default component.exports